import { httpSingleton } from '@/lib/http-client';
import { constructUrl } from '@/lib/utils';
import { AdvisorModel, PaginatedResponseModel } from '@/lib/models';

export const advisorService = {
	getAdvisoryTeam(queryParameters?: { size?: number; page?: number; programId?: string }) {
		return httpSingleton.orchestrateRequest<PaginatedResponseModel & { advisors: (AdvisorModel)[] }>({
			method: 'GET',
			url: constructUrl('/advisory-service/api/v1/advisory-team', queryParameters),
		});
	},
	getAdvisorById(advisorId: string) {
		return httpSingleton.orchestrateRequest<{ advisor: AdvisorModel }>({
			method: 'GET',
			url: `/advisory-service/api/v1/advisor/${advisorId}`,
		});
	},
	followAuthor(data: { authorId: string; follow: boolean }) {
		return httpSingleton.orchestrateRequest<void>({
			method: 'POST',
			url: `/advisory-service/api/v1/advisor/follow`,
			data,
		});
	},
};
